exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-error {}\n.page-error .error-mark {\n    margin-bottom: 33px;\n}\n\n.page-error header h1 {\n    font-size: 10em;\n    font-weight: 400;\n}\n\n.page-error header p {\n    margin-bottom: 30px;\n    font-size: 30px;\n    text-transform: uppercase;\n}\n\n.page-error h2 {\n    margin-bottom: 30px;\n}\n\n.page-error .error-advise {\n    margin-bottom: 25px;\n    color: #a9afb5;\n}\n\n.page-error .go-back:hover{text-decoration: underline}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/evs/page-error/style.css
// module id = ../../../../../src/app/pages/admin/evs/page-error/style.css
// module chunks = 3